import React from 'react';
import classNames from 'classnames/bind';
import TimeAgo from 'react-timeago';
import { Container, Label, Icon } from 'semantic-ui-react';

import DateLocalizer from '../utils/DateLocalizer';
import Camera from './Camera';

import '../styles/UserBadge.css';

const JOIN_STATUS = 'join';
const AFK_STATUS = 'afk';
const LEAVE_STATUS = 'leave';

class UserBadge extends React.Component {
  constructor(props) {
    super(props);

    this.handleSnapshot = this.handleSnapshot.bind(this);
    this.toggleCameraView = this.toggleCameraView.bind(this);

    this.state = {
      currentDate: new Date(),
      cameraOpen: false
    };
  }

  componentDidMount() {
    this.localTimeInterval = setInterval(
      () => this.setState({ currentDate: new Date() }),
      1000
    );
  }

  componentWillUnmount() {
    clearInterval(this.localTimeInterval);
  }

  get userName() {
    const { user } = this.props;

    return user.name;
  }

  get statusColor() {
    const { user } = this.props;

    if (user.status) {
      switch (user.status.action) {
        case JOIN_STATUS:
          return 'green';
        case AFK_STATUS:
          return 'yellow';
        case LEAVE_STATUS:
          return 'red';
        default:
          return 'grey';
      }
    }

    return 'grey';
  }

  get reason() {
    return this.props.user.status && this.props.user.status.reason;
  }

  get location() {
    return this.props.location;
  }

  get localTime() {
    return (
      this.props.user.status &&
      this.props.user.status.time_zone &&
      new DateLocalizer(this.state.currentDate).toTimeInZone(
        this.props.user.status.time_zone
      )
    );
  }

  get currentStatusTimestamp() {
    return (
      this.props.user.status && new Date(this.props.user.status.created_at)
    );
  }

  get action() {
    return this.props.user.status && this.props.user.status.action;
  }

  get isCurrent() {
    const { currentUser, user } = this.props;

    return currentUser && currentUser.id === user.id;
  }

  handleSnapshot(snapshot) {
    this.props.onSnapshot(snapshot);
    this.toggleCameraView();
  }

  toggleCameraView() {
    this.setState({ cameraOpen: !this.state.cameraOpen });
  }

  render() {
    const { user } = this.props;
    const { cameraOpen } = this.state;

    const badgeClassNames = {
      'UserBadge--on': this.action === JOIN_STATUS,
      'UserBadge--afk': this.action === AFK_STATUS,
      'UserBadge--off': this.action === LEAVE_STATUS
    };

    return (
      user && (
        <div
          className={classNames('UserBadge', badgeClassNames)}
          style={{
            backgroundImage: `url(${
              user.snapshot ? user.snapshot.image_url : user.avatar_url
            })`
          }}
        >
          <Container fluid className="UserBadge__overlay">
            {this.isCurrent && !cameraOpen && (
              <Icon
                link
                name="camera"
                size="huge"
                className="UserBadge__toolbar__item"
                onClick={this.toggleCameraView}
              />
            )}
            {!this.isCurrent &&
              this.action === AFK_STATUS &&
              this.currentStatusTimestamp && (
                <TimeAgo date={this.currentStatusTimestamp} />
              )}
          </Container>
          {this.isCurrent && cameraOpen && (
            <Camera
              onCapture={this.handleSnapshot}
              captureHandler={capture => {
                this.takeSnapshot = capture;
              }}
            />
          )}
          {this.isCurrent &&
            (cameraOpen && (
              <div className="UserBadge__toolbar">
                <Icon
                  link
                  name="check"
                  size="large"
                  className="UserBadge__toolbar__item"
                  onClick={this.takeSnapshot}
                />{' '}
                <Icon
                  link
                  name="cancel"
                  size="large"
                  className="UserBadge__toolbar__item"
                  onClick={this.toggleCameraView}
                />
              </div>
            ))}
          <div className="UserBadge__name">
            {this.userName}
            {this.isCurrent && <span> (you)</span>}
          </div>
          <div className="UserBadge__data">
            <span className="UserBadge__location">{this.location} </span>
            <span className="UserBadge__local-time">
              <Icon name="clock" />
              {this.localTime}
            </span>
          </div>
          {this.reason && (
            <Label
              content={this.reason}
              color="black"
              className="UserBadge__reason"
            />
          )}
          <Label
            empty
            circular
            size="large"
            color={this.statusColor}
            className="UserBadge__status"
          />
        </div>
      )
    );
  }
}

export default UserBadge;



// WEBPACK FOOTER //
// ./src/components/UserBadge.js